import { render, staticRenderFns } from "./OrdersCard.vue?vue&type=template&id=48ffc916&scoped=true&"
import script from "./OrdersCard.vue?vue&type=script&lang=js&"
export * from "./OrdersCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ffc916",
  null
  
)

export default component.exports